export default __webpack_public_path__ + "fc75b52f83adce98a1bf0590afdd3db0.png";